module.exports = __webpack_public_path__ + "img/account.7ecbba94.png";